import { getRedirectUrl } from '@amzn/d2c-application-website-common';
import { Paths } from 'src/paths/Paths';
import { getStage, getAsinStage } from 'src/utils/roadieHelper';
import { getIsPreview } from 'src/utils/siteUtils';

export { TEST_CLIENT_ID, POP_UP_WIDTH_AND_HEIGHT } from '@amzn/d2c-application-website-common';

export const getRedirectUrlForCurrentStage = (): string => {
  // Only preview traffic can carry an ?asinStage= override (e.g. the Ops Portal's
  // "Preview with Gamma Testing ID" button). Outside preview, always use the site's
  // own deploy stage — never let a stray asinStage param redirect a live LWA login
  // to a different stage's client_id.
  // In preview, the redirect_uri must match the stage RoadieService actually fetched
  // the LWA client_id from (getAsinStage()), or LWA rejects it as not allowlisted.
  const stage = getIsPreview() ? getAsinStage() : getStage();
  return getRedirectUrl(stage, Paths.closeWindow);
};
